@let configuration = configurationSg();

<div class="atn-space-report-account-list">
  <atn-ds-widget title="Configuration">
    <div class="atn-space-report-account-list__configuration">
      <atn-ds-select-single
        label="Format"
        [items]="formatItems"
        [value]="configuration.format"
        [required]="true"
        (valueChange)="formatChangeHandler($event)"
      />
    </div>
  </atn-ds-widget>

  <atn-ds-widget title="Filters">
    <div class="atn-space-report-account-list__filters">
      <atn-ds-section name="Organization">
        <div class="atn-space-report-account-list__filter-section">
          <atn-space-dimension-filter [plugin]="organizationFilterPlugin" />
        </div>
      </atn-ds-section>
    </div>
  </atn-ds-widget>
</div>
